module.exports = __webpack_public_path__ + "static/media/map-01.03e53421.svg";